<template>
  <div
    class="text-center lg:max-w-4xl mx-auto w-full font-body-medium font-medium sm:font-body-large text-gray-2"
  >
    <div class="px-6 mb-12">
      <SectionHeader class="mb-2">Your Own Dedicated HR Manager</SectionHeader>
      <p>
        Bambee gives you a dedicated HR Manager who helps you craft HR policy
        and maintain&nbsp;compliance.
      </p>
    </div>
    <div class="flex">
      <img
        src="~/assets/images/ashley-wide.jpg"
        class="object-cover lg:object-none object-right-bottom hidden md:block lg:mr-12 w-32 lg:w-auto flex-shrink-0"
        alt=""
        load="lazy"
      />
      <div
        class="gap-8 sm:gap-10 grid xs:grid-cols-2 mx-6 lg:mx-0 flex-grow pb-16"
      >
        <div v-for="{ title, description, icon } in items" :key="title">
          <HighlightedIcon :icon="icon" class="mb-4" size="large" />
          <h3 class="font-body-medium sm:font-body-large font-bold mb-2">
            {{ title }}
          </h3>
          <p>{{ description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HighlightedIcon } from '@bambeehr/pollen';

import SectionHeader from '@/components/SectionHeader';

export default {
  components: { HighlightedIcon, SectionHeader },
  props: {
    items: {
      type: Array,
      default: () => [
        {
          title: 'HR Policy & Procedures',
          description:
            'We’ll work with you to craft your internal HR policies that fit the way you run your business.',
          icon: 'clipboardCheckSolid',
        },
        {
          title: 'Employer Coaching & Guidance',
          description:
            'Full remote HR support, available to help by phone, email, or chat. Consider us an extension of your team.',
          icon: 'binoculars',
        },
        {
          title: 'Compliant Onboarding & Terminations',
          description:
            'Our powerful platform lets you onboard, terminate, and take corrective action easily and securely.',
          icon: 'doorOpenSolid',
        },
        {
          title: 'General & Compensation Compliance',
          description:
            'Bambee makes sure your business stays compliant with nuanced wage and hour regulations.',
          icon: 'badgeDollarSolid',
        },
      ],
    },
  },
};
</script>
